export default {
  name: 'AuthDetailDialog',
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      innerVisible: false
    };
  },
  methods: {
    open: function open() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$emit('update:detail', payload);
      this.innerVisible = true;
    },
    close: function close() {
      this.innerVisible = false;
    }
  }
};